import { cn } from '@sandtech-hub-monorepo/ui-kit';
import {
  ConductCaseCategory,
  ConductCaseSeverity,
} from '@sandtech-hub-monorepo/ehub-client';
import { getSeverityLabel } from '@sandtech-hub-monorepo/ui-kit-site';

const SEVERITY_COLORS: Record<ConductCaseSeverity, string> = {
  [ConductCaseSeverity.ScholasticWarning]: 'text-warning',
  [ConductCaseSeverity.AcademicProbation]: 'text-destructive',
  [ConductCaseSeverity.AcademicSuspension]: 'text-destructive',
  [ConductCaseSeverity.AcademicDismissal]: 'text-destructive',
};

const CATEGORY_SHORT_LABELS: Record<ConductCaseCategory, string> = {
  [ConductCaseCategory.GpaBelowMinimum]: 'GPA',
  [ConductCaseCategory.AcademicIntegrityViolation]: 'Academic integrity',
};

interface Props {
  label: string;
  severity: ConductCaseSeverity;
  category: ConductCaseCategory;
}

export const SeverityRow = ({ label, severity, category }: Props) => (
  <div className="bg-muted/10 border border-muted/40 rounded-xl flex justify-between items-center px-4 py-2.5">
    <span className="text-sm font-medium text-foreground">{label}</span>
    <span className={cn('text-sm font-medium', SEVERITY_COLORS[severity])}>
      {getSeverityLabel(severity)} ({CATEGORY_SHORT_LABELS[category]})
    </span>
  </div>
);
